import type { GetServerSideProps, NextPage } from 'next'
import { SEOHead } from '~/components/business/SEOHead'
import { Layout } from '~/layouts/default'
import { Container } from '~/components/ui/Container'
import { Row, Col } from 'antd'
import Link from 'next/link'
import { SwapRightOutlined } from '@ant-design/icons'
import { MyBtn } from '~/components/ui/MyBtn'
import { SingleProduct } from '~/components/business/SingleProduct'
import { CommonSection } from '~/components/business/CommonSection'

import { FeatureSection } from '~/components/pages/home/FeatureSection'
import { RecommendModule } from '~/components/pages/home/RecommendModule'
import { CreateModule } from '~/components/pages/home/CreateModule'
import { ArticleModule } from '~/components/pages/home/ArticleModule'
import { CreatorModule } from '~/components/pages/home/CreatorModule'
import { CollectionModule } from '~/components/pages/home/CollectionModule'
import { MysteryBoxModule } from '~/components/pages/home/MysteryBoxModule'
import { PresaleModule } from '~/components/pages/home/PresaleModule'
import AiArtworks from '~/components/pages/home/AiArtworks'
import { RankListModule } from '~/components/pages/home/RankListModule'
import { GlobalRequest } from '~/components/global-requset'
import {
  GET_CREATOR_LIST,
  GET_PRODUCT_LIST,
  GET_BANNER_LIST,
  GET_CATEGORY_LIST,
  GET_RECOMMEND_PRODUCT_LIST,
  GET_STAR_PRODUCT_LIST,
  GET_NEW_PRODUCT_LIST,
  GET_COLLECTION_LIST,
  GET_MYSTERY_BOX_LIST,
  GET_INDEX_PAGE_NOTICE,
  GET_ARTICLE_LIST,
  GET_PRESALE_ACTIVITY_LIST,
  GET_AI_SAME_STYLE_RANK,
  GET_AI_PICTURE_COUNT_RANK,
  GET_AI_FANS_COUNT_RANK,
} from '~/graphqls/gqls'
import {
  getBannerList,
  getBannerList_marketingModule_bannerList,
  getCategoryList,
  getCategoryList_marketingModule_categoryList,
  CopyrightUserRole,
  getProductList,
  getProductList_itemModule_productList_edges_node,
  getCreatorList,
  getCreatorList_creatorList_edges_node,
  getRecommendProductList,
  getRecommendProductListVariables,
  getStarProductList,
  getProductListVariables,
  ArtworkSortEnum,
  getNewProductList,
  getCreatorListVariables,
  getRecommendProductList_itemModule_productList_edges_node,
  getNewProductList_itemModule_productList,
  SystemCode,
  getMysteryBoxList,
  getMysteryBoxListVariables,
  listFlash,
  listFlashVariables,
  listFlash_articleGraph_listFlash_edges_node,
  FlashCategory,
  getArticleList,
  getArticleListVariables,
  getArticleList_articleGraph_articleList_edges_node,
  getAiSameStyleRank,
  getAiSameStyleRankVariables,
  getAiPictureCountRank,
  getAiPictureCountRankVariables,
  getAiFansCountRank,
  getAiFansCountRankVariables,
  QueryDateEnum,
  getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  getAiPictureCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  getAiFansCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  SortType,
  CrCategoryFilter,
  ArtworkDBType,
} from '~/graphqls/types'
import { observer } from 'mobx-react'
import { getGraphData } from '~/utils'
import { useAuth } from '~/hooks/useAuth'

const Home: NextPage<{
  bannerData: getBannerList_marketingModule_bannerList[]
  categoryList: getCategoryList_marketingModule_categoryList[]
  aiArtworksCategries: getCategoryList_marketingModule_categoryList[]
  recommendProductList: getRecommendProductList_itemModule_productList_edges_node[]
  hotProductList: getProductList_itemModule_productList_edges_node[]
  starProductList: getProductList_itemModule_productList_edges_node[]
  articeList: getArticleList_articleGraph_articleList_edges_node[]
  creatorList: getCreatorList_creatorList_edges_node[]
  newProductList: getNewProductList_itemModule_productList[]
  indexNoticeList: listFlash_articleGraph_listFlash_edges_node[]
  aiSameRankList: getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
  aiPictureRankList: getAiPictureCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
  aiFansRankList: getAiFansCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
  aiArtworks: getNewProductList_itemModule_productList[]
}> = ({
  bannerData,
  categoryList,
  recommendProductList,
  hotProductList,
  starProductList,
  articeList,
  creatorList,
  newProductList,
  indexNoticeList,
  aiSameRankList,
  aiPictureRankList,
  aiFansRankList,
  aiArtworks,
  aiArtworksCategries,
}) => {
  const { isAiCreator, isCreator, isOrganization } = useAuth()

  return (
    <Layout>
      <SEOHead />
      <>
        <FeatureSection
          categoryList={categoryList}
          bannerData={bannerData}
          noticeList={indexNoticeList}
        />
        <section>
          {aiArtworks?.length >= 4 && (
            <CommonSection
              title="AI 商用作品"
              style={{ paddingBottom: 8 }}
              extra={
                <MyBtn type="default">
                  <Link href="/market">
                    <a>
                      查看更多 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <Container>
                <AiArtworks
                  categoryList={aiArtworksCategries}
                  aiArtworks={aiArtworks}
                />
              </Container>
            </CommonSection>
          )}

          {!!recommendProductList?.[0]?.artworkList?.length && (
            <CommonSection
              title="今日推荐"
              extra={
                <MyBtn type="default">
                  <Link href="/recommend">
                    <a>
                      查看往日 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <Container>
                <RecommendModule
                  data={recommendProductList?.[0]?.artworkList}
                />
              </Container>
            </CommonSection>
          )}
          {!!aiSameRankList.length &&
          !!aiPictureRankList.length &&
          !!aiFansRankList.length ? (
            <CommonSection
              title="排行榜"
              extra={
                <MyBtn type="default">
                  <Link href="/rank/aiCreators">
                    <a>
                      查看更多 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <Container>
                <RankListModule
                  data={{ aiSameRankList, aiPictureRankList, aiFansRankList }}
                />
              </Container>
            </CommonSection>
          ) : null}

          {!!hotProductList.length && (
            <CommonSection
              title="热门创作"
              style={{ paddingBottom: 8 }}
              extra={
                <MyBtn type="default">
                  <Link href="/market">
                    <a>
                      查看更多 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <Container>
                <Row gutter={32}>
                  {hotProductList.map(art => (
                    <Col span={6} key={art.id}>
                      <SingleProduct needReport showRank data={art} />
                    </Col>
                  ))}
                </Row>
              </Container>
            </CommonSection>
          )}

          {!!starProductList.length && (
            <CommonSection title="新星创作" style={{ paddingBottom: 8 }}>
              <Container>
                <Row gutter={32}>
                  {starProductList.map(product => (
                    <Col span={6} key={product.id}>
                      <SingleProduct data={product} showRank />
                    </Col>
                  ))}
                </Row>
              </Container>
            </CommonSection>
          )}

          {!!articeList.length && (
            <CommonSection
              title="最新资讯"
              extra={
                <MyBtn type="default">
                  <Link href="/articles">
                    <a>
                      查看更多 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <ArticleModule data={articeList} />
            </CommonSection>
          )}

          {!!creatorList.length && (
            <CommonSection
              title="发现创作者"
              extra={
                <MyBtn type="default">
                  <Link href="/creators">
                    <a>
                      查看更多 <SwapRightOutlined />
                    </a>
                  </Link>
                </MyBtn>
              }
            >
              <CreatorModule data={creatorList} />
            </CommonSection>
          )}

          {!!newProductList.length && (
            <CommonSection
              title="开始创作"
              style={{ paddingBottom: 8, marginBottom: -40 }}
              extra={
                <MyBtn type="default">
                  {isCreator || isAiCreator || isOrganization ? (
                    <Link href="/upload-product">
                      <a>
                        上传作品 <SwapRightOutlined />
                      </a>
                    </Link>
                  ) : (
                    <Link href="/to-be-creator">
                      <a>
                        申请入驻
                        <SwapRightOutlined />
                      </a>
                    </Link>
                  )}
                </MyBtn>
              }
            >
              <CreateModule data={newProductList} />
            </CommonSection>
          )}
        </section>
      </>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  // ai 商用作品
  const categoriesRes = await client
    .query<getCategoryList>({
      query: GET_CATEGORY_LIST,
      fetchPolicy: 'no-cache',
      variables: {
        crCategoryFilter: CrCategoryFilter.AI_MARKET,
      },
    })
    .catch(() => {})

  const categoryListVal =
    categoriesRes?.data?.marketingModule?.categoryList || []
  const categoryList = [
    {
      id: 0,
      name: '最新',
      categoryList: [],
    },
    ...(categoryListVal || []),
  ]
  const productRes = await client.query<
    getProductList,
    getProductListVariables
  >({
    query: GET_PRODUCT_LIST,
    variables: {
      offset: 0,
      first: 8,
      params: {
        // 首次： 全部-最新
        categoryIdList: null,
        sortField: ArtworkSortEnum.VERIFY_TIME,
        sort: SortType.DESC,
        type: ArtworkDBType.AI_COPYRIGHT,
      },
    },
    fetchPolicy: 'no-cache',
  })
  // ---------------------------------------------------------------------------
  const [
    bannerRes,
    categoryListRes,
    recommendProductListRes,
    hotProductListRes,
    starProductListRes,
    articleRes,
    creatorListRes,
    newProductListRes,
  ] = await Promise.all([
    client
      .query<getBannerList>({
        query: GET_BANNER_LIST,
        fetchPolicy: 'no-cache',
        context: {
          headers: {
            system_code: SystemCode.COPYRIGHT,
          },
        },
      })
      .catch(() => {}),
    client
      .query<getCategoryList>({
        query: GET_CATEGORY_LIST,
        fetchPolicy: 'no-cache',
        variables: {
          crCategoryFilter: CrCategoryFilter.NO_AI_ARTWORK,
        },
      })
      .catch(() => {}),
    client
      .query<getRecommendProductList, getRecommendProductListVariables>({
        query: GET_RECOMMEND_PRODUCT_LIST,
        variables: {
          offset: 0,
          first: 1,
        },
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getProductList, getProductListVariables>({
        query: GET_PRODUCT_LIST,
        variables: {
          offset: 0,
          first: 8,
          params: {
            sortField: ArtworkSortEnum.HOT,
            types: [ArtworkDBType.AI_COPYRIGHT, ArtworkDBType.NORMAL],
          },
        },
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getStarProductList>({
        query: GET_STAR_PRODUCT_LIST,
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getArticleList, getArticleListVariables>({
        query: GET_ARTICLE_LIST,
        variables: {
          offset: 0,
          first: 8,
        },
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getCreatorList, getCreatorListVariables>({
        query: GET_CREATOR_LIST,
        variables: {
          offset: 0,
          first: 8,
        },
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getNewProductList>({
        query: GET_NEW_PRODUCT_LIST,
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
    client
      .query<getMysteryBoxList, getMysteryBoxListVariables>({
        query: GET_MYSTERY_BOX_LIST,
        variables: {
          first: 3,
          offset: 0,
        },
        fetchPolicy: 'no-cache',
      })
      .catch(() => {}),
  ])
  /** TODO: 当前promise.all超过10个，会导致jest-work报错。找其他替代方法。暂时将可后获取的数据放在第二all当中 */
  const [indexNoticeRes, collectioRes, worksRes, creatorsRes] =
    await Promise.all([
      client
        .query<listFlash, listFlashVariables>({
          query: GET_INDEX_PAGE_NOTICE,
          variables: {
            page: {
              first: 3,
              offset: 0,
            },
            param: {
              flashCategory: FlashCategory.ANNOUNCEMENT,
              indexShow: true,
            },
          },
          fetchPolicy: 'no-cache',
        })
        .catch(() => {}),
      client
        .query<getAiSameStyleRank, getAiSameStyleRankVariables>({
          query: GET_AI_SAME_STYLE_RANK,
          variables: {
            first: 3,
            offset: 0,
            date: QueryDateEnum.SEVEN_DAYS,
          },
          fetchPolicy: 'no-cache',
        })
        .catch(() => {}),
      client
        .query<getAiPictureCountRank, getAiPictureCountRankVariables>({
          query: GET_AI_PICTURE_COUNT_RANK,
          variables: {
            first: 3,
            offset: 0,
            date: QueryDateEnum.SEVEN_DAYS,
          },
          fetchPolicy: 'no-cache',
        })
        .catch(() => {}),
      client
        .query<getAiFansCountRank, getAiFansCountRankVariables>({
          query: GET_AI_FANS_COUNT_RANK,
          variables: {
            first: 3,
            offset: 0,
            date: QueryDateEnum.ALL_TIME,
          },
          fetchPolicy: 'no-cache',
        })
        .catch(() => {}),
    ])
  return {
    props: {
      initialState,
      bannerData: bannerRes?.data?.marketingModule?.bannerList || [],
      categoryList: categoryListRes?.data?.marketingModule?.categoryList || [],
      aiArtworks: getGraphData(
        productRes?.data?.itemModule?.productList?.edges || []
      ),
      aiArtworksCategries: categoryList,
      recommendProductList: getGraphData(
        recommendProductListRes?.data?.itemModule?.productList?.edges || []
      ),
      hotProductList: getGraphData(
        hotProductListRes?.data?.itemModule?.productList?.edges || []
      ),
      starProductList: starProductListRes?.data?.itemModule?.productList || [],
      articeList: getGraphData(
        articleRes?.data?.articleGraph?.articleList?.edges || []
      ),
      creatorList: getGraphData(creatorListRes?.data?.creatorList?.edges || []),
      newProductList: newProductListRes?.data?.itemModule?.productList || [],
      indexNoticeList: getGraphData(
        indexNoticeRes?.data?.articleGraph?.listFlash?.edges || []
      ),

      aiSameRankList: getGraphData(
        collectioRes?.data?.copyrightStatisticsModule?.aiCreatorsList?.edges ||
          []
      ),
      aiPictureRankList: getGraphData(
        worksRes?.data?.copyrightStatisticsModule?.aiCreatorsList?.edges || []
      ),
      aiFansRankList: getGraphData(
        creatorsRes?.data?.copyrightStatisticsModule?.aiCreatorsList?.edges ||
          []
      ),
    },
  }
}

export default observer(Home)
